<!--
	作者：Shujuan Sun
	时间：2017-04-24
	描述：车辆监控页面_右上角动态按钮组
-->
<template>
	 <!--车辆监控页面_右上角按钮组开始-->
	<div class="btn-group boot-button right_act_ctrl right_baidu_btn" role="group" aria-label="...">
		<!--<a v-if="permission.indexOf('monitorVehicle_panelExpansionPointChase') == -1" class="drawTool" :class="[currentMenu===0 ?'active':'normal-tool']" @click="trackCar(0)" data-toggle="tooltip" data-placement="bottom" :title="carSearching">
			<img src="../../../assets/project/images/map/map_icon_41.png" width="20" height="20" :alt="carSearching"/>
		</a>-->
		<a v-if="permission.indexOf('monitorVehicle_panelExpansionPointAlarm') == -1" class="drawTool" :class="[currentMenu===1 ?'active':'normal-tool']" @click="warnings(1)">
			<img src="../../../assets/project/images/map/text_icon_22.png" width="44" height="44" alt="预警"/>
		</a>
		<a class="drawTool" :class="[currentMenu===2 ?'active':'normal-tool']" @click="makePlan(2)">
			<img src="../../../assets/project/images/map/text_icon_23.png" width="44" height="44" alt="规划"/>
		</a>
		<a v-if="permission.indexOf('monitorVehicle_panelExpansionPointChange') == -1" class="drawTool" :class="[currentMenu===3 ?'active':'normal-tool']" @click="unusualMove(3)">
			<img src="../../../assets/project/images/map/text_icon_24.png" width="44" height="44" :alt="stopException" v-show="stopException=='异动'"/>
			<img src="../../../assets/project/images/map/text_icon_25.png" width="44" height="44" :alt="stopException" v-show="stopException=='解除异动'"/>
		</a> 
		<a v-if="permission.indexOf('monitorVehicle_panelExpansionPointGarrison') == -1" class="drawTool" :class="[currentMenu===4 ?'active':'normal-tool']" @click="defend(4)">
			<img src="../../../assets/project/images/map/text_icon_26.png" width="44" height="44" :alt="defendStatus" v-show="defendStatus=='驻防'"/>
			<img src="../../../assets/project/images/map/text_icon_27.png" width="44" height="44" :alt="defendStatus" v-show="defendStatus=='显示驻防区域'"/>
		</a>
		<a class="drawTool" :class="[currentMenu===5 ?'active':'normal-tool']" @click="streetView(5)">
			<img src="../../../assets/project/images/map/text_icon_28.png" width="44" height="44" alt="街景"/>
		</a>
		<a v-if="permission.indexOf('monitorVehicle_panelExpansionPointTrace') == -1" class="drawTool" :class="[currentMenu===6 ?'active':'normal-tool']" @click="carRail(6)">
			<img src="../../../assets/project/images/map/text_icon_29.png" width="44" height="44" alt="跟踪"/>
		</a>
		<a v-if="permission.indexOf('monitorVehicle_panelExpansionPointCommand') == -1" class="drawTool" :class="[currentMenu===7 ?'active':'normal-tool']" @click="instructions(7)">
			<img src="../../../assets/project/images/map/text_icon_2a.png" width="44" height="44" alt="命令"/>
		</a>
		<a v-if="permission.indexOf('monitorVehicle_panelExpansionPointTrack') == -1" class="drawTool" :class="[currentMenu===8 ?'active':'normal-tool']" @click="addTrack(8)">
			<img src="../../../assets/project/images/map/text_icon_2b.png" width="44" height="44" alt="轨迹"/>
		</a>
		<button style="outline:none;" type="button" class="menu_btn right_act_btn" id="tool" @click="toggleMenu" :class="[rollUp?'downArrow':'upArrow']" data-toggle="vehicletip" data-placement="bottom" title="折叠"></button>
	</div>
	 <!--车辆监控页面_右上角按钮组结束-->
</template>
<script> 
	import {mapState} from 'vuex'
	import {goTabMixin} from 'util/util'
	export default{
		name:'MenuVehicle',
		mixins:[goTabMixin],
		data(){
			return {
				permission:this.$store.state.permission.permission["monitorVehicle"]?this.$store.state.permission.permission["monitorVehicle"]:[],
				currentMenu:'',
				rollUp:false
			}
		},
		props:['defendStatus','clickedInfo','carSearching','stopException'],
		computed:mapState({
			mapIndex:state=>state.monitor.mapIndex,
			vehicles:state=>state.monitor.vehicles
		}),
		watch:{
			'clickedInfo.vehicleId'(val){
				//右上角menuVehicle初始化
				this.currentMenu = '' 
				//右侧悬浮框初始化：
				this.$store.dispatch('initMapTab')
			}
		},
		mounted(){
			$(function () {//启用tooltip
			  $('[data-toggle="vehicletip"]').tooltip()
			})
		},
		updated(){
			this.$nextTick(function(){
				$('[data-toggle="vehicletip"]').tooltip()
				$('.drawTool').hover(function(){
					$(this).attr('title',$(this).attr('title')).tooltip('fixTitle').tooltip('show')
				})
			})
		},
		destroyed(){
			$('[data-toggle="vehicletip"]').tooltip('hide')
		},
		methods: {
			toggleMenu(){
				this.rollUp = !this.rollUp
				$(".btn-group .normal-tool").toggle(300);
			},
			carRail(index){//追加跟踪队列-跳转到跟踪窗口
				const obj = {//点开到跟踪标签
						name:'车辆跟踪视窗',
						id:'PageCarRail',
						route:'/indexhome/carRail',
						No:'carRail'
				}
				this.addTab(obj,index);
				this.$http.post(process.env.API_ROOT + '/monitor/track/tracks?vehicleId=' + this.clickedInfo.vehicleId)
					.then((res)=>{
						this.$store.dispatch('getTrackMap')
					},(res)=>{
						this.$store.dispatch('showRailModal',res.body.message)
					})
					.catch((res)=>{
						this.$store.dispatch('showRailModal','请求异常')
					})
			},
			addTrack(index){//添加车辆到轨迹队列
				
				//1,跳转到轨迹回放页面
				this.openDidiVehicleTrace()
				//2,追加到轨迹队列
				let arr = []
				arr.push(this.clickedInfo.vehicleId)
				const param = {
					vehicleIds:arr,
					type:4
				}
				this.$store.dispatch('addTrackList',param).then(()=>{
					this.$store.dispatch('getTraces',1)
				})
			},
			addTab(obj,index){//点击轨迹打开‘轨迹回放’标签
				this.currentMenu = index;
				this.$router.push(obj.route);
				this.$store.dispatch('addTab',obj);
			},
			instructions(index){//点击打开“设备命令”
				this.currentMenu = index;
				const obj = {
					id:'DeviceInstructions',
					No:5,
					name:'设备命令'
				}
				this.$store.dispatch('addMapTab',obj)
				//获取指令列表
				const param = {
					carInfo:this.clickedInfo
				}
				this.$store.dispatch('getInstList',param)
			},
			streetView(index){//街景
				this.currentMenu = index;
				this.$emit('streetView')
			},
			defend(index){//驻防
				this.currentMenu = index;
				if(this.defendStatus=='显示驻防区域'){
					this.$emit('stopDefend')
				}else{//驻防
					this.$emit('defend')
				}
			},
			unusualMove(index){//异动
				if(this.stopException == '解除异动'){
					this.$emit('removeException')
				}else{
					this.$emit('unusualMove')
				}
				this.currentMenu = index;
			},
			makePlan(index){//规划
				this.currentMenu = index;
				this.$emit('makePlan')
			},
			warnings(index){//点击打开车辆预警tab
				this.currentMenu = index;
				const obj = {
					id:'VehicleAlarm',
					No:0,
					name:'预警详情'
				}
				this.$store.dispatch('addMapTab',obj)
			},
			trackCar(index){//点击设置‘追车’
				this.currentMenu = index; 
				if(this.carSearching == '追车'){//未追车状态，点击可以设置追车 
					this.$emit('startTrack')  
				}else{//追车状态，点击解除追车
					this.$emit('stopTrack') 
				}
				
			}
		}
		
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// MenuVehicle.vue?ce768884